import { useSearchParams } from "react-router-dom";
import { useEffect, useState } from "react";
import BaseKeyword from "../../games/Keyword/BaseKeyword";
import { identifyUser } from "../../analytics";
import { processPublicationData } from "./helper";

export const OAKLANDSIDE = "LN9Jni5ngvYYkeEh9yXosG";

// testing
// export const OAKLANDSIDE = "AdXbHK5DNgwyBWpckJRkRF";

const fetchPublicationByEncodedId = async (encodedId) => {
  const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
  try {
    const response = await fetch(`${API_BASE_URL}/keywords/${encodedId}`);
    if (!response.ok) throw new Error("Publication not found");
    return await response.json();
  } catch (error) {
    console.error("Failed to fetch publication:", error);
    return null;
  }
};

const getGameCustomization = (id) => {
  if (id === OAKLANDSIDE) {
    return {
      title: "The Oaklandside Keyword",
      titleColor: "#014062",
      shareText: "I played The Oaklandside Keyword",
      modalBackgroundColor: "#00324F",
      shareUrl: `https://oaklandside.org/oak-keyword/`,
      bannerPath: `${process.env.PUBLIC_URL}/assets/customer-logos/banner/oaklandside-key.png`,
      backgroundColor: "#EAD3A6",
      buttonColor: "#014062",
    };
  }

  return {};
};

const KeywordEmbed = () => {
  const [searchParams] = useSearchParams();
  const [publication, setPublication] = useState(null);

  const encodedId = searchParams.get("id");
  const playerUID = searchParams.get("uid");

  useEffect(() => {
    if (encodedId) {
      fetchPublicationByEncodedId(encodedId).then(setPublication);
    }

    // Enable analytics for embedded content
    if (encodedId) {
      // Identify the user if uid is provided
      if (playerUID) {
        identifyUser(playerUID, {
          publication_id: encodedId,
          source: "embedded_game",
        });
      }
    }
  }, [encodedId, playerUID]);

  if (!publication) {
    return null; // You might want to add a loading skeleton here
  }

  const customization = getGameCustomization(encodedId);
  const processedData = processPublicationData(publication.keywords);
  return (
    <BaseKeyword
      title={customization.title ?? "Keyword"}
      isEmbedded={true}
      titleColor={customization.titleColor ?? "#014062"}
      shareText={customization.shareText ?? "I played Keyword"}
      modalBackgroundColor={customization.modalBackgroundColor ?? "#00324F"}
      // Use real data!
      getWordForDate={processedData.getWordForDate}
      findLatestAvailableDate={processedData.findLatestAvailableDate}
      bannerPath={customization.bannerPath ?? null}
      backgroundColor={customization.backgroundColor ?? "white"}
      buttonColor={customization.buttonColor ?? "black"}
      shareUrl={customization.shareUrl ?? "https://flyingcometgames.com"}
      publicationId={encodedId}
    />
  );
};

export default KeywordEmbed;
